import { useEffect, useState } from 'react'

import { useAppDispatch } from '@app/utils/redux'

import { getIconsCache } from '@app/store/actions/contexts/iconCache'
import { createThunk } from '@app/store/thunk'

import { loadIcon } from './loadIcon'

export const useIcon = (size: string, name: string) => {
  const dispatch = useAppDispatch()
  const [icon, setIcon] = useState(dispatch(getIcon(size, name)))

  useEffect(() => {
    const cached = dispatch(getIcon(size, name))
    if (cached) {
      setTimeout(() => {
        setIcon(cached)
      })
    } else {
      void dispatch(loadIcon(size, name)).then(setIcon)
    }
  }, [size, name, dispatch])

  return icon
}

const getIcon = (size: string, name: string) => {
  return createThunk((dispatch): string | null => {
    const iconCache = dispatch(getIconsCache())
    return iconCache.get(size, name) ?? null
  })
}
